import { render, staticRenderFns } from "./RankListTable.vue?vue&type=template&id=5c6c4478&"
import script from "./RankListTable.vue?vue&type=script&lang=js&"
export * from "./RankListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports